import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Check } from 'lucide-react';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import LeadForm from '@/components/LeadForm';
import CalendlySection from '@/components/CalendlySection';

const POINTS = [
  'Roster matching against genuine audience overlap, not follower counts',
  'Contracted deliverables, usage rights and reporting from day one',
  'A written response from an account lead, informed by our own performance data',
];

export default function PitchBrand() {
  return (
    <div className="min-h-screen bg-[#0B0B0B]">
      <Navbar />
      <main>
        <section className="relative pt-32 pb-20 lg:pt-40 lg:pb-28 overflow-hidden">
          <div className="absolute inset-0 fine-grid opacity-70" />
          <div className="absolute -top-40 right-1/4 w-[560px] h-[560px] bg-[#2563EB]/15 blur-[160px] rounded-full" />

          <div className="relative max-w-[1320px] mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-12 lg:gap-16 items-start">
            <div className="lg:col-span-7">
              <Link
                to="/"
                className="inline-flex items-center gap-2 text-sm text-white/50 hover:text-[#3B82F6] transition-colors mb-10"
              >
                <ArrowLeft className="w-4 h-4" /> Back to the agency
              </Link>

              <span className="text-[11px] font-semibold uppercase tracking-[0.2em] text-[#3B82F6] block mb-5">
                Pitch a Brand
              </span>
              <h1 className="font-display font-bold text-white tracking-tight text-4xl lg:text-6xl leading-[1.05]">
                Bring us the brand. <span className="text-[#3B82F6]">We will bring the fit.</span>
              </h1>
              <p className="mt-7 text-lg text-white/60 font-light leading-relaxed max-w-xl">
                Tell us the brand, the category and the outcome you need. Our team reviews every submission and responds
                with the roster placement, structure and commercial terms that fit.
              </p>

              <ul className="mt-9 space-y-3.5">
                {POINTS.map((p) => (
                  <li key={p} className="flex gap-3 items-start">
                    <Check className="w-4 h-4 text-[#3B82F6] mt-1 shrink-0" />
                    <span className="text-white/65 font-light">{p}</span>
                  </li>
                ))}
              </ul>
            </div>

            <div className="lg:col-span-5 w-full">
              <div className="rounded-xl border border-white/15 bg-white/[0.04] backdrop-blur-sm p-7 lg:p-9">
                <h2 className="font-display font-bold text-2xl text-white tracking-tight">Submit your brief</h2>
                <p className="mt-3 text-sm text-white/55 font-light leading-relaxed">
                  Reviewed by an account lead, with a written response back to you.
                </p>
                <div className="mt-7">
                  <LeadForm
                    type="pitch_brand"
                    buttonLabel="Submit Your Brand Brief"
                    showAdSpend={false}
                    showMessage
                    redirectTo="/thank-you"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        <CalendlySection
          title="Rather brief us on a call?"
          body="Book thirty minutes with an account lead to talk through the brand, the category and the roster placement you have in mind."
        />
      </main>
      <Footer />
    </div>
  );
}